module.exports = __webpack_public_path__ + "static/media/ic_临床试验练习平台.80bcd4ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_临床试验练习平台.svg
// module id = 408
// module chunks = 0